import { render } from "./MapScreenBottomBarShimmer.vue?vue&type=template&id=49bf0586"
import script from "./MapScreenBottomBarShimmer.vue?vue&type=script&lang=js"
export * from "./MapScreenBottomBarShimmer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__